import type { AwardId, Pace, TeamId } from './types';

/** Ids of the 11 default categories shipped by `@20fight/content`. */
export const DEFAULT_CATEGORY_IDS = [
  'yemekler',
  'tatlilar',
  'icecekler',
  'guncel-futbolcular',
  'efsane-futbolcular',
  'filmler',
  'diziler',
  'sarkicilar',
  'unlu-kadinlar',
  'arabalar',
  'sehirler-tatil',
] as const;

export const DEFAULT_TEAM_NAMES: Record<TeamId, string> = { A: 'Mavi Takım', B: 'Kırmızı Takım' };

export const LIMITS = {
  minRounds: 1,
  maxRounds: 12,
  minPlayersPerTeam: 2,
  minTeamPlayers: 4,
  maxTeamPlayers: 12,
  maxJurors: 4,
  /** Non-spectator members (12 team + 4 jury). */
  maxMembers: 16,
  maxSpectators: 30,
  maxPendingJoins: 20,
  nameMax: 20,
  teamNameMax: 24,
  passwordMax: 64,
  startPoints: 20,
  itemsPerRound: 10,
  itemsPerBuyer: 5,
  /** Host migration grace (scaled by `timerScale`). */
  hostGraceMs: 20_000,
} as const;

export const MIN_SCORE = 1;
export const MAX_SCORE = 10;
/** Default highlighted score and no-vote fallback. */
export const NEUTRAL_SCORE = 5.5;
/** All 19 legal scores: 1, 1.5, …, 10. */
export const SCORE_VALUES: readonly number[] = Array.from({ length: 19 }, (_, i) => 1 + i * 0.5);

export type TimerKey =
  | 'roundIntro'
  | 'juryItem'
  | 'auctionIntro'
  | 'pick'
  | 'open'
  | 'turn'
  | 'broke'
  | 'sold'
  | 'autoAssign';

/** Timer durations in seconds per pace (spec §2.8), before `timerScale`. */
export const TIMERS: Record<Pace, Record<TimerKey, number>> = {
  normal: {
    roundIntro: 5,
    juryItem: 20,
    auctionIntro: 3,
    pick: 15,
    open: 15,
    turn: 12,
    broke: 12,
    sold: 4,
    autoAssign: 1.5,
  },
  fast: {
    roundIntro: 4,
    juryItem: 12,
    auctionIntro: 2,
    pick: 8,
    open: 8,
    turn: 7,
    broke: 7,
    sold: 3,
    autoAssign: 1,
  },
};

export const AWARD_EMOJI: Record<AwardId, string> = {
  esnaf: '🧿',
  mirasyedi: '💸',
  cimri: '🪙',
  'sert-juri': '🔨',
  'yumusak-kalp': '🧸',
};

/** Minimum number of given votes to qualify for the jury awards. */
export const JURY_AWARD_MIN_VOTES = 5;
